import { Datepicker, DateRangePicker } from "vanillajs-datepicker";
import { DotNet } from "@microsoft/dotnet-js-interop";
import * as bootstrap from 'bootstrap';

// Extend Navigator type to include msSaveOrOpenBlob
declare global {
    interface Navigator {
        msSaveOrOpenBlob?: (blob: Blob, defaultName?: string) => boolean;
    }
}

export const createDatePicker = (dotNetObjectReference: DotNet.DotNetObject, el: HTMLElement, maxDate?: string | number | Date) => {
    let datePicker = new Datepicker(el, {
        buttonClass: "btn",
        enableOnReadonly: true,
        maxDate: maxDate,
        todayButton: true,
        todayButtonMode: 0,
        autohide: true,
        clearButton: true
    });
    datePicker.element.addEventListener('changeDate', (e: any) => {
        datePicker.element.blur();
        dotNetObjectReference.invokeMethodAsync("DateChanged", e.detail.date);
    });
    return datePicker;
}
export const getAntiForgeryToken = (): string | null => {
    let elements = document.getElementsByName('__RequestVerificationToken');
    if (elements.length > 0) {
        let el = elements[0] as HTMLInputElement;
        if (el instanceof HTMLInputElement) {
            return el.value;
        }
    }

    console.warn('no anti forgery token found!');
    return null;

}
export const saveAsFile = (filename: string, bytesBase64: string) => {
    if (navigator.msSaveOrOpenBlob) {
        let data = window.atob(bytesBase64);
        let bytes = new Uint8Array(data.length);
        for (let i = 0; i < data.length; i++) {
            bytes[i] = data.charCodeAt(i);
        }
        let blob = new Blob([bytes.buffer], { type: "application/octet-stream" });
        navigator.msSaveOrOpenBlob(blob, filename);
    }
    else {
        let link = document.createElement('a');
        link.download = filename;
        link.href = `data:application/octet-stream;base64,${bytesBase64}`;
        document.body.appendChild(link);//for firefox
        link.click();
        document.body.removeChild(link);
    }
}
export const triggerFileDownload = (fileName: string, url: string, tokenValue?: string) => {
    const anchorElement = document.createElement('a');
    anchorElement.href = url;

    if (fileName) {
        anchorElement.download = fileName;
    }

    anchorElement.click();
    anchorElement.remove();
}
export const downloadFileFromStream = async (fileName: string, contentStreamReference: Response) => {
    const arrayBuffer: ArrayBuffer = await contentStreamReference.arrayBuffer();
    const blob = new Blob([arrayBuffer]);

    const url = URL.createObjectURL(blob);

    triggerFileDownload(fileName, url);

    URL.revokeObjectURL(url);
}

/**
 * Generates an avatar taking the initials of a string
 * @param name the name to change to an avatar
 * @returns a Data Url to embed in an img element
 */
export const generateAvatar = (name: string): string => {
    let initials = name.split(' ').map(function (str) { return str ? str[0].toUpperCase() : ""; }).join('');
    let canvas = document.createElement('canvas');
    let radius = 30.0;
    let margin = 0.0;
    canvas.width = radius * 2 + margin * 2;
    canvas.height = radius * 2 + margin * 2;

    // Get the drawing context
    let ctx = canvas.getContext('2d');
    if (!ctx) {
        return "";
    }
    ctx.beginPath();
    ctx.arc(radius + margin, radius + margin, radius, 0, 2 * Math.PI, false);
    ctx.closePath();
    ctx.fillStyle = "#F7F0FF";
    ctx.fill();
    ctx.fillStyle = "#8E6ABF";
    ctx.font = "bold 30px Arial";
    ctx.textAlign = 'center';
    ctx.fillText(initials, radius + 1, radius * 4 / 3 + margin);
    return canvas.toDataURL();
}
//export const downloadFile = (url: string, fileName: string, authorizationToken?: string) => {
//    fetch(url, {
//        method: 'GET',
//        headers: new Headers({
//            'Authorization': 'Bearer ' + authorizationToken
//        })
//    })
//        .then(response => response.blob())
//        .then(blob => {
//            const downloadUrl = window.URL.createObjectURL(blob);
//            const a = document.createElement('a');
//            a.style.display = 'none';
//            a.href = downloadUrl;
//            a.download = fileName;
//            document.body.appendChild(a);
//            a.click();
//            window.URL.revokeObjectURL(downloadUrl);
//            a.remove();
//        })
//        .catch(error => console.error('Download error:', error));
//}
export const downloadFile = (url: string, fileName: string, authorizationToken?: string): boolean => {
    try {
        const anchorElement = document.createElement('a');
        anchorElement.href = url;
        anchorElement.download = fileName ?? '';
        anchorElement.click();
        anchorElement.remove();
        return true

    } catch (e) {
        console.error(e);
        return false;
    }



    //fetch(url, {
    //    method: 'GET',
    //    headers: new Headers({
    //        'Authorization': 'Bearer ' + authorizationToken
    //    })
    //})
    //    .then(response => response.blob())
    //    .then(blob => {
    //        const downloadUrl = window.URL.createObjectURL(blob);
    //        const a = document.createElement('a');
    //        a.style.display = 'none';
    //        a.href = downloadUrl;
    //        a.download = fileName;
    //        document.body.appendChild(a);
    //        a.click();
    //        window.URL.revokeObjectURL(downloadUrl);
    //        a.remove();
    //    })
    //    .catch(error => console.error('Download error:', error));
}
export const disposeTooltips = (els: Element[] | string[]) => {
    els.forEach((el) => {
        let tooltip = bootstrap.Tooltip.getInstance(el);
        if (tooltip)
            tooltip.dispose();
    })
}
export const addClass = (el: Element, className: string) => {
    if (el) {
        el.classList.add(className);
    }
}
export const removeClass = (el: Element, className: string) => {
    if (el) {
        el.classList.remove(className);
    }
}

export const addClassByClassName = (classNameToSearch: string, classNameToAdd: string) => {
    document.querySelectorAll("." + classNameToSearch).forEach((el) => {
        addClass(el, classNameToAdd);
    })
}
document.addEventListener("DOMContentLoaded", () => {
    let tooltips: bootstrap.Tooltip[] = [];
    bootstrap.Tooltip.Default.allowList.dl = [];
    bootstrap.Tooltip.Default.allowList.dt = [];
    bootstrap.Tooltip.Default.allowList.dd = [];

    window.addEventListener("load", () => {
        let tooltip = new bootstrap.Tooltip(document.body, {
            selector: '[data-bs-toggle="tooltip"],[rel="tooltip"]',
            container: "body",
            trigger: "hover"
        });
        tooltips.push(tooltip);
    });
});
window.bootstrap = bootstrap;// require("bootstrap");